export var IS_FOCUSABLE_ATTRIBUTE = 'data-is-focusable';